module.exports = __webpack_public_path__ + "741e50bfb5adcb78126e1e716760d8a9.png";